import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { NzImage, NzImageService } from 'ng-zorro-antd/image';

@Component({
  selector: 'app-input-panel',
  templateUrl: './input-panel.component.html',
  styleUrls: ['./input-panel.component.scss'],
})
export class InputPanelComponent {
  @Input() cover = false;
  @Input() ratio = 1;
  loading = false;
  @Input() value: any;
  @Output() valueChange = new EventEmitter<{
    detail: string;
    image: string[];
  }>();

  constructor(private api: UserApiService, private image: NzImageService) {}

  onTextChange(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    this.value.detail = textarea.value;
    this.emitChange();
  }

  emitChange() {
    this.valueChange.emit({
      detail: this.value.detail,
      image: this.value.image,
    });
  }

  clear(img: any) {
    const index = this.value.image.indexOf(img);
    if (index !== -1) {
      this.value.image.splice(index, 1);
      this.emitChange();
    }
  }

  onFileChange(e: any) {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    const file = files[0];
    this.uploadFile(file);
  }

  async uploadFile(file: any) {
    try {
      this.loading = true;
      const r = await this.api.postQiniu(file);
      this.value.image.push(r.url);
      this.emitChange();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  preview(img: any) {
    if (!img) {
      return;
    }
    const image: NzImage = {
      src: img,
    };
    this.image.preview([image]);
  }
}
